class BundleBuilder extends HTMLElement {
  constructor() {
    super();
    this.productWrapperSelector = '[js-product-wrapper]';
    this.selectProductBtnSelector = '[js-select-product-btn]';
    this.selectProductQuantitySelector = '[js-select-product-quantity]';
    this.quantityInputSelector = '[js-quantity-input]';
    this.incrementBtnSelector = '[js-quantity-increment]';
    this.decrementBtnSelector = '[js-quantity-decrement]';
    this.selectionBoxSelector = '[js-selection-box]';
    this.selectionBoxListSelector = '[js-selection-box-list]';

    this.selectionCountWrappers = this.querySelectorAll('[js-selection-count-wrapper]');
    this.selectionCounts = this.querySelectorAll('[js-selection-count]');
    this.addToCartBtns = this.querySelectorAll('[js-bundle-addToCart-btn]');
    this.comparePriceWrappers = this.querySelectorAll('[js-product-compare-price]');
    this.priceWrappers = this.querySelectorAll('[js-product-price]');
    this.bundleCompletedMsgs = this.querySelectorAll('[js-bundle-completed-msg]');
    this.bundleProcessMsgs = this.querySelectorAll('[js-bundle-processing-msg]');
    this.selectionRemainingCounts = this.querySelectorAll('[js-remaining-count]');
    this.upsellAddToCartBtn = this.querySelector('[js-upsell-addToCart-btn]');
    this.selectionBoxMainWrapper = this.querySelector('[js-selection-box-wrapper]');
    this.closeBtn = this.querySelector('[js-close-btn]');

    const self = this;
    setTimeout(() => {
      self.style.opacity = 1;
    }, 1000)

    if( this.upsellAddToCartBtn) {
      this.upsellProduct();
    }

    this.totalBox = 4;
    this.products = [];

    this.closeBtn.addEventListener('click', () => {
      this.selectionBoxMainWrapper.classList.remove('active');
    })

    this.addEventListener('click', (event) => {
      this.querySelectorAll(this.selectProductBtnSelector).forEach(selectProductBtn => {
        if(selectProductBtn.contains(event.target)) {

          const parent = selectProductBtn.closest(this.productWrapperSelector);
          const quantityField = parent.querySelector(this.quantityInputSelector);
          quantityField.stepUp();
     
          parent.classList.add('selected');
          this.addProductToBox(parent);

          if(!this.selectionBoxMainWrapper.classList.contains('active')) {
            this.selectionBoxMainWrapper.classList.add('active');
          }

        }
      })

      this.querySelectorAll(this.decrementBtnSelector).forEach(decrementBtn => {
        if(decrementBtn.contains(event.target)) {
          const parent = decrementBtn.closest(this.productWrapperSelector);
          const currentProductId = Number(parent.dataset.productId);
          const quantityField = parent.querySelector(this.quantityInputSelector);
          quantityField.stepDown();

          this.removeProductFromBox(currentProductId, parent);
        }
      })

      this.querySelectorAll(this.incrementBtnSelector).forEach(incrementBtn => {
        if(incrementBtn.contains(event.target)) {
          const parent = incrementBtn.closest(this.productWrapperSelector);
          const quantityField = parent.querySelector(this.quantityInputSelector);
          quantityField.stepUp();
          this.addProductToBox(parent);

        }
      })

    })

    this.addToCartBtns.forEach(addToCartBtn => {
      addToCartBtn.addEventListener('click', (e) => {

        this.addToCartBtns.forEach(addToCartBtn => {
          addToCartBtn.classList.add('loading');
          addToCartBtn.querySelector('.loading__spinner').classList.remove('hidden');
       })

        const products = [];

        this.products.forEach(item => {
          if(!products[item.id]) {
            products[item.id] = {
              id: item.id,
              quantity: 1,
              properties: {
                bundle: "builder"
              }
            }
          } else { 
            products[item.id].quantity += 1;
          }
        })
  
        const items = [];
  
        for (let key in products) {
          items.push(products[key])
        }

        this.addToCart(items);
      })
    })    

    document.addEventListener('renderBundleProduct:init', () => {
      this.updateAfterFilterApply();
    })

    this.createBox(this.totalBox);
  }

  updateAfterFilterApply() {
    this.fillProductInSelectionBox(this.products);
    
    this.products.forEach(product => {
      const selectedProductWrapper = this.querySelector(`${this.productWrapperSelector}[data-product-id="${product.id}"]`);
      const currentProducts = this.products.filter(product => product.id == Number(selectedProductWrapper.dataset.productId));
      selectedProductWrapper.classList.add('selected');
      selectedProductWrapper.querySelector(this.quantityInputSelector).value = currentProducts.length;
    })
  }

  removeProductFromBox(id, parent) {
    const otherProducts = this.products.filter(product => product.id !== id);
    const currentProducts = this.products.filter(product => product.id == id);
    currentProducts.splice(0, 1)
    if(currentProducts.length === 0) {
      parent.classList.remove('selected');
    }
    this.products = [...currentProducts, ...otherProducts];
    this.fillProductInSelectionBox(this.products);
  }

  addProductToBox(parent) {
    const imageUrl = parent.dataset.productImageUrl;
    const productId = Number(parent.dataset.productId);
    const title = parent.dataset.productTitle;
    const benefit = parent.dataset.productBenefit;
    const price = Number(parent.dataset.productPrice);
    const comparePrice = Number(parent.dataset.productComparePrice);

    this.products.push({
      id: productId,
      imageUrl,
      title,
      benefit,
      price,
      quantity: 1,
      comparePrice,
    })

    this.fillProductInSelectionBox(this.products);
  }

  createBox(number) {
    this.querySelector(this.selectionBoxListSelector).innerHTML = '';
    let productbox = '';
    for (let i = 0; i < number; i++) {
        productbox += `<div class="custom-bundle_beta-block" data-index="${i}" js-selection-box>
        <div class="custom-bundle_beta-cart">
          <div class="image">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none">
              <path
                d="M12 2V22"
                stroke="#0C0C0C"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M22 12H1.99997"
                stroke="#0C0C0C"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>
        </div>
      </div>`
    }
    this.querySelector(this.selectionBoxListSelector).insertAdjacentHTML('beforeend', productbox);
  }

  //  Filling product into the box
  fillProductInSelectionBox(products) {
    this.createBox(this.totalBox);
    products.forEach((item, index) => {
        this.querySelector(`${this.selectionBoxSelector}[data-index="${index}"]`).innerHTML = '';
        this.querySelector(`${this.selectionBoxSelector}[data-index="${index}"]`).classList.add('filled');
        this.querySelector(`${this.selectionBoxSelector}[data-index="${index}"]`).setAttribute('data-product-id', item.id);
        this.querySelector(`${this.selectionBoxSelector}[data-index="${index}"]`).insertAdjacentHTML('beforeend', `
        <div class="custom-bundle_beta-cart">
          <div class="image">
          <img src="${item.imageUrl}">
          </div>
        </div>`)
    })
    this.updateStatus();
    this.updatePrice();
  }

  updatePrice() {
    let totalComparePrice = 0;
    this.products.forEach(product => {
      if(product.comparePrice) {
        totalComparePrice += product.comparePrice;
      }
    })

    let totalPrice = 0;
    this.products.forEach(product => {
      if(product.price) {
        totalPrice += product.price;
      }
    })

    this.comparePriceWrappers.forEach(comparePriceWrapper => {
        comparePriceWrapper.innerHTML = `$${(totalPrice / 100).toFixed(2).toString().replace(/\.00$/, '')}`
    })

    this.priceWrappers.forEach(priceWrapper => {
      const discountInPercentage = Number(this.dataset.discount);
      if(discountInPercentage) {
        const discountPrice = (discountInPercentage/100)*totalPrice;
        const priceWithDiscount = totalPrice - discountPrice;
        priceWrapper.innerHTML = `$${(priceWithDiscount / 100).toFixed(2).toString().replace(/\.00$/, '')}`
      } else {
        priceWrapper.innerHTML = `$${(totalPrice / 100).toFixed(2).toString().replace(/\.00$/, '')}`
      }
    })
  }

  updateStatus() {
    this.querySelectorAll(this.incrementBtnSelector).forEach(item => {
      item.classList.remove('disabled')
    })
    this.querySelectorAll(this.selectProductBtnSelector).forEach(item => {
      item.classList.remove('disabled')
    })

    this.selectionCountWrappers.forEach(selectionCountWrapper => {
      selectionCountWrapper.classList.remove('hidden');
    })
   
    this.addToCartBtns.forEach(addToCartBtn => {
      addToCartBtn.classList.add('hidden');
    })
  
    this.bundleCompletedMsgs.forEach(bundleCompletedMsg => {
      bundleCompletedMsg.classList.add('hidden');
    })
    this.bundleProcessMsgs.forEach(bundleProcessMsg => {
      bundleProcessMsg.classList.remove('hidden');
    })
    this.selectionCounts.forEach((selectionCount) => {
      selectionCount.innerHTML = `${this.products.length}/${this.totalBox}`;
    })

    this.selectionRemainingCounts.forEach((selectionRemainingCount) => {
      selectionRemainingCount.innerHTML = this.totalBox - this.products.length;
    })

    if(this.products.length === 0) {
      this.bundleProcessMsgs.forEach(bundleProcessMsg => {
        bundleProcessMsg.classList.add('hidden');
      })
    }

    if(this.products.length === this.totalBox) {
      this.querySelectorAll(this.incrementBtnSelector).forEach(item => {
        item.classList.add('disabled')
      })
      this.querySelectorAll(this.selectProductBtnSelector).forEach(item => {
        item.classList.add('disabled')
      })
     
      this.bundleCompletedMsgs.forEach(bundleCompletedMsg => {
        bundleCompletedMsg.classList.remove('hidden');
      })      
      this.bundleProcessMsgs.forEach(bundleProcessMsg => {
        bundleProcessMsg.classList.add('hidden');
      })
    }

    if(this.products.length >= 2) {
      this.addToCartBtns.forEach(addToCartBtn => {
        addToCartBtn.classList.remove('hidden');
      })
      this.selectionCountWrappers.forEach(selectionCountWrapper => {
        selectionCountWrapper.classList.add('hidden');
      })
    }
  }

  async addToCart(products) {
    const requestBody = {
      items: products
    }

    const cartDrawer = document.querySelector('cart-drawer');
    requestBody.sections = cartDrawer.getSectionsToRender().map((section) => section.id);

    try {
      const resp = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        body: JSON.stringify(requestBody),
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await resp.json();

      this.addToCartBtns.forEach(addToCartBtn => {
        addToCartBtn.classList.remove('loading');
        addToCartBtn.querySelector('.loading__spinner').classList.add('hidden');
      })

      cartDrawer.renderContents(data);
      document.querySelector('cart-drawer').open();
  
    } catch(err){
      console.log({ err })
    }
  }


  upsellProduct() {
    this.upsellAddToCartBtn.addEventListener('click', (e) => {
      this.upsellAddToCartBtn.classList.add('loading');
      this.upsellAddToCartBtn.querySelector('.loading__spinner').classList.remove('hidden');

      const productId = Number(this.upsellAddToCartBtn.dataset.productId);

      const upsellAddToCart = async () => {

        const requestBody = {
          items: [
            {
              id: productId,
              quantity: 1,
            }
          ]
        }
    
        const cartDrawer = document.querySelector('cart-drawer');
        requestBody.sections = cartDrawer.getSectionsToRender().map((section) => section.id);

        try {
          const resp = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            body: JSON.stringify(requestBody),
            headers: {
              "Content-Type": "application/json",
            },
          });
          const data = await resp.json();
    
          this.upsellAddToCartBtn.classList.remove('loading');
          this.upsellAddToCartBtn.querySelector('.loading__spinner').classList.add('hidden');

          cartDrawer.renderContents(data);
          document.querySelector('cart-drawer').open();
      
        } catch(err){
          console.log({ err })
        }
      }

      upsellAddToCart();
  
    })
  }

}

customElements.define('bundle-builder', BundleBuilder)